import { getSelectRecipientModalInitialState } from './bb-select-recipient-modal-initial-state';
import leadsService from '@/services/contacts/leads-service.js';
import { isEmpty } from 'lodash';

const state = getSelectRecipientModalInitialState();

const mutations = {
	RESET_SELECT_RECIPIENT_MODAL(state) {
		Object.assign(state, getSelectRecipientModalInitialState());
	},
	SET_SEARCHTERM(state, payload) {
		state.searchTerm = payload;
	},
	SET_PAGE_NUMBER(state, payload) {
		state.pageNumber = payload;
	},
	SET_PAGE_SIZE(state, payload) {
		state.pageSize = payload;
	},
	SET_CONTACTS(state, payload) {
		state.contacts = [...state.contacts, ...payload];
	},
	CLEAR_CONTACTS(state) {
		state.contacts = [];
	},
	SET_SELECTED_BROKERS(state, selectedBrokerIds) {
		state.selectedBrokers = selectedBrokerIds;
	},
	SET_SELECTED_FILTERS(state, payload) {
		state.selectedFilters = payload;
	},
	SET_FILTER_CHANGE_CONFIRMATION(state, payload) {
		state.filterChangeConfirmation = payload;
	},
	SET_TOTAL_COUNT(state, payload) {
		state.totalCount = payload;
	},
	SET_NO_RESULTS_FOUND(state, payload) {
		state.noResultsFound = payload;
	},
	SET_ERROR(state, payload) {
		state.error = payload;
	},
	SET_IS_LOADING(state, payload) {
		state.isLoading = payload;
	},
	SET_LEAD_IDS(state, payload) {
		state.leadIds = payload;
	},
	SET_SEND_ALL_CONFIRMATION(state, payload) {
		state.sendAllConfirmation = payload;
	},
};

const actions = {
	resetSelectRecipientModal({ commit }) {
		commit('RESET_SELECT_RECIPIENT_MODAL');
	},
	setSearchTerm({ commit }, data) {
		commit('SET_SEARCHTERM', data);
	},
	setPageNumber({ commit }, data) {
		commit('SET_PAGE_NUMBER', data);
	},
	setPageSize({ commit }, data) {
		commit('SET_PAGE_SIZE', data);
	},
	setContacts({ commit }, data) {
		commit('SET_CONTACTS', data);
	},
	clearContacts({ commit }) {
		commit('CLEAR_CONTACTS');
	},
	setSelectedBrokers({ commit }, data) {
		commit('SET_SELECTED_BROKERS', data);
	},
	setSelectedFilters({ commit }, data) {
		commit('SET_SELECTED_FILTERS', data);
	},
	setFilterChangeConfirmation({ commit }, data) {
		commit('SET_FILTER_CHANGE_CONFIRMATION', data);
	},
	setTotalCount({ commit }, data) {
		commit('SET_TOTAL_COUNT', data);
	},
	setNoResultsFound({ commit }, data) {
		commit('SET_NO_RESULTS_FOUND', data);
	},
	setError({ commit }, data) {
		commit('SET_ERROR', data);
	},
	setIsLoading({ commit }, data) {
		commit('SET_IS_LOADING', data);
	},
	setLeadIds({ commit }, data) {
		commit('SET_LEAD_IDS', data);
	},
	setSendAllConfirmation({ commit }, data) {
		commit('SET_SEND_ALL_CONFIRMATION', data);
	},
	async getBBLeads({ dispatch, getters, state }) {
		try {
			dispatch('setIsLoading', true);
			const { entityId, contactsIds } = !getters.isImpersonated
				? getters.currentUserRolodexIds
				: getters.currentImpersonatedUserRolodexId;

			const payload = {
				data: {
					entityId,
					contactsIds: isEmpty(state.selectedBrokers)
						? contactsIds
						: state.selectedBrokers,
					typesIds: state.selectedFilters ? state.selectedFilters : [],
				},
				activeInd: true,
				searchTerm: state.searchTerm,
				sortColumn: 'lastName',
				sortDirection: 'asc',
				pageNumber: state.pageNumber,
				pageSize: state.pageSize,
			};
			const { items, totalCount } = await leadsService.getSearchLeads(payload);
			dispatch('setContacts', items);
			if (items.length === 0) {
				dispatch('setNoResultsFound', true);
			} else {
				dispatch('setNoResultsFound', false);
			}
			dispatch('setTotalCount', totalCount);
			dispatch('setError', false);
		} catch (error) {
			dispatch('setError', error);
		} finally {
			dispatch('setIsLoading', false);
		}
	},
};

const getters = {
	showTable(state) {
		return !state.isLoading && !state.error && !state.noResultsFound;
	},
	showSearch(state, getters) {
		return getters.showTable || state.totalAvailableContacts !== null;
	},
	showPagination(state, getters) {
		return getters.showTable && state.totalCount > 10;
	},
	showNoResults(state) {
		return !state.isLoading && !state.error && state.noResultsFound;
	},
	showError(state) {
		return !state.isLoading && state.error;
	},
};

export default {
	state,
	actions,
	mutations,
	getters,
};
